import React from "react";
import { BarChart3, FolderOpen, TrendingUp, Percent } from "lucide-react";
import KPICard from "../components/dashboard/KPICard";
import ProjectStatusChart from "../components/dashboard/ProjectStatusChart";
import BudgetTrackingChart from "../components/dashboard/BudgetTrackingChart";
import ActiveProjectsTable from "../components/dashboard/ActiveProjectsTable";
import ValidationQueue from "../components/dashboard/ValidationQueue";

export default function DashboardPage() {
  return (
      <div className="p-8 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Tableau de bord CAPEX</h1>
            <p className="text-gray-600">Période: Q2 2025</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <KPICard
                title="Budget Total"
                value="25,8"
                format="currency"
                trend="up"
                trendValue="+4,2%"
                icon={BarChart3}
                color="teal"
            />
            <KPICard
                title="Projets Actifs"
                value={47}
                trend="up"
                trendValue="+2 nouveaux ce mois-ci"
                icon={FolderOpen}
                color="yellow"
            />
            <KPICard
                title="ROI Moyen"
                value="12,3"
                format="percentage"
                trend="down"
                trendValue="-0,8% vs objectif annuel"
                icon={TrendingUp}
                color="green"
            />
            <KPICard
                title="Budget Consommé"
                value="68"
                format="percentage"
                trend="up"
                trendValue="En ligne avec prévisions"
                icon={Percent}
                color="blue"
            />
          </div>

          <div className="grid lg:grid-cols-2 gap-8 mb-8">
            <ProjectStatusChart />
            <BudgetTrackingChart />
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            <ActiveProjectsTable />
            <ValidationQueue />
          </div>
        </div>
      </div>
  );
}